import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInfoSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconInfoSimple"><Path d="M11 9C11.8284 9 12.5 9.67157 12.5 10.5V19H14.5C14.7761 19 15 19.2239 15 19.5C15 19.7761 14.7761 20 14.5 20H9.5C9.22386 20 9 19.7761 9 19.5C9 19.2239 9.22386 19 9.5 19H11.5V10.5C11.5 10.2239 11.2761 10 11 10H9.5C9.22386 10 9 9.77614 9 9.5C9 9.22386 9.22386 9 9.5 9H11Z" fill="currentColor"/><Path d="M12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInfoSimple;
